import { Link } from "react-router-dom";
import papers from "./papers";
import Subscribe from "./Subscribe";
import useTitle from "./useTitle";

const LEVEL_ZH = { s3: "中三", s4: "中四", s5: "中五", s6: "中六" };

// Exam papers with answers for one level, in the school exam format: Section A(1), A(2) and B,
// the marks of every part, and an answer page with the marks.
const PapersPage = ({ level }) => {
    const zh = LEVEL_ZH[level];
    const list = papers.filter((p) => p.level === level);
    useTitle(`${zh}數學試卷連答案 PDF ${level.toUpperCase()} Maths Exam Papers｜上學期`);

    return (
        <div className="topic-page papers-page">
            <p className="crumb">
                <Link to="/">Home</Link> › <Link to={`/${level}`}>{zh}數學練習</Link> › 試卷
            </p>

            <h1>{zh}數學試卷連答案</h1>
            <h2 className="topic-en">{level.toUpperCase()} Maths Exam Papers with Answers</h2>

            <p className="topic-intro">
                按學校考試格式出嘅模擬試卷：甲部（一）、甲部（二）、乙部，每題標明分數，卷末附答案同分數分配。
                中英雙版，免費下載。限時做完再對答案，就知道自己考試時大概攞到幾多分。
            </p>

            {list.map((p) => {
                const base = `/pdf/${level}/${level}-${p.slug}-`;
                return (
                    <div className="paper-list" key={p.slug}>
                        <h2>{p.zh}</h2>
                        <p className="paper-meta">{p.en}</p>
                        <p className="paper-meta">{p.chapters}</p>
                        <p className="paper-meta">{p.info}</p>
                        <a href={`${base}chi.pdf`} target="_blank" rel="noreferrer">試卷（中文版）</a>
                        <a href={`${base}eng.pdf`} target="_blank" rel="noreferrer">Paper (English)</a>
                    </div>
                );
            })}

            <p className="level-notes-link">
                <Link to={`/${level}`}>{zh}各課題練習 PDF（附答案）→</Link>
            </p>
            <p className="level-notes-link">
                <Link to={`/${level}/notes`}>{zh}數學筆記：公式總表＋常犯錯誤 →</Link>
            </p>

            <Subscribe where={`${level}-papers`} />
        </div>
    );
}

export default PapersPage;
